// The Vue build version to load with the `import` command
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import { i18n } from './setup/i18n-setup'
import VueCookies from 'vue-cookies'
import Vuex from 'vuex'

import bootstrapSetup from '@/setup/bootstrapSetup'
import { Notifier } from '@airbrake/browser'
import { initValidations } from './validations/validations'
import httpClient from '@/api/httpClient'
import { store } from '@/store/store'
import VueNotification from 'vue-notification'
import PortalVue from 'portal-vue'
import VueResizeObserver from 'vue-resize-observer'
import VueScrollTo from 'vue-scrollto'
import AtlasHelpers from '@/helpers/atlas'
let froalaRTESetup
if (!process.env.VUE_APP_IS_PUBLIC) {
  froalaRTESetup = require('@/setup/froala-rte-setup').default
}

// Initiate Vee Validate
initValidations()

Vue.use(VueNotification)
Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(VueCookies)
Vue.use(Vuex)
Vue.use(PortalVue)
Vue.use(VueResizeObserver)
Vue.use(VueScrollTo)
Vue.use({
  install () {
    Vue.atlasHelpers = AtlasHelpers
    Vue.prototype.$atlasHelpers = AtlasHelpers
  }
})
Vue.config.productionTip = false
Vue.prototype.atlasInfoFetched = false
Vue.prototype.DEFAULT_UNIT_BAR_COLOR = '#d83f43'
Vue.prototype.$http = httpClient

if (process.env.VUE_APP_WORKING_ENV === 'local') {
  Vue.config.errorHandler = (err) => { console.error(err) }
} else {
  const airbrake = new Notifier({
    environment: process.env.VUE_APP_WORKING_ENV,
    projectId: 315680,
    projectKey: 'ccfd591e433f00fb17f388689dab37e1'
  })

  const ERRORS_TO_SKIP_NOTIFICATION_VIA_AIRBRAKE = [
    'Extension context invalidated.',
    'angular is not defined',
    "Cannot read properties of null (reading 'classList')",
    'e.getBoundingClientRect is not a function',
    "Cannot read properties of null (reading 'parentElement')",
    "Cannot read properties of null (reading 'sendMessage')",
    'Network Error',
    'Request failed with status code 4',
    'Request failed with status code 5',
    'Avoided redundant navigation to current location:'
  ]
  const shouldIgnoreNotice = (notice) => notice.errors.some(({ message, backtrace }) => {
    return ERRORS_TO_SKIP_NOTIFICATION_VIA_AIRBRAKE.some(e => message.includes(e)) ||
      backtrace.some(({ file }) => /(^\/Users\/|((chrome|moz|safari(-web)?)-extension|webkit-masked-url):)/.test(file))
  })
  airbrake.addFilter((notice) => shouldIgnoreNotice(notice) ? null : notice)

  Vue.config.errorHandler = function (error, vm, info) {
    console.error(error)
    if (process.env.VUE_APP_WORKING_ENV !== 'test' && error?.shouldSendAirbrake) {
      airbrake.notify({
        error,
        params: { info }
      })
    }
  }
}
// imports froala rte with all plugins
if (!process.env.VUE_APP_IS_PUBLIC && typeof froalaRTESetup === 'function') {
  froalaRTESetup()
}

// imports bootstrap (ltr, rtl) with variables rewrites
bootstrapSetup()

/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  store,
  router,
  i18n,
  components: { App },
  data: function () {
    return {
      breadcrumbs: ''
    }
  }
}).$mount('#app')
